import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { listCollection, type Row } from '../../lib/db';

export function JobList() {
  const [rows, setRows] = useState<Row[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    listCollection('jobs', 'createdAt').then((r) => {
      setRows(r);
      setLoading(false);
    });
  }, []);

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="fw-bold m-0">Jobs</h3>
        <Link to="/jobs/new" className="btn btn-success btn-sm">
          New job
        </Link>
      </div>
      {loading ? (
        <p className="text-muted">Loading…</p>
      ) : (
        <table className="table table-hover">
          <thead>
            <tr>
              <th>Title</th>
              <th>Status</th>
              <th>Location</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id}>
                <td>{String(r.title ?? '')}</td>
                <td>
                  <span className={`badge bg-${r.status === 'published' ? 'success' : 'secondary'}`}>
                    {String(r.status ?? '')}
                  </span>
                </td>
                <td>{String(r.locationDisplay ?? '—')}</td>
                <td className="text-end">
                  <Link to={`/jobs/${r.id}`} className="btn btn-sm btn-outline-secondary">
                    Edit
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </>
  );
}
